<script setup>
import { PermissionNames } from "~/configs/permission_names";
import { useOrganizationStore } from "~/projects/crm/stores/organizationStore";
const handleCloseDialog = () => {
  organizationStore.setCreateModalVisibility(false);
};
const organizationStore = useOrganizationStore();
</script>
<template>
  <div>
    <div
      v-if="isUserPermitted(PermissionNames.ORGANIZATION_CREATE)"
      class="cursor-pointer text-light-purple underline-light-purple- underline text-xs w-full flex justify-end dark:text-light-purple-bar"
      @click.prevent="organizationStore.setCreateModalVisibility(true)"
    >
      <el-tooltip content="Add Organization" placement="top">
        <Svgs
          name="plus"
          class="w-5 h-5 text-light-sec-purple dark:text-white"
          stroke-width="1.2"
        />
      </el-tooltip>
    </div>
    <el-dialog
      v-model="organizationStore.showCreateModal"
      :before-close="handleCloseDialog"
      :lock-scroll="false"
      :modal="false"
      :show-close="true"
      :destroy-on-close="true"
      class="rounded-lg"
      draggable
      align-center
      width="35%"
    >
      <template #header="{ titleId, titleClass }">
        <div class="my-header flex flex-col gap-1">
          <h4 :id="titleId" class="text-md" :class="titleClass">
            Create Organization
          </h4>
        </div>
      </template>
      <div class="subtext-dialog">
        <OrganizationsCreateForm :show-edit-modal-header="false" /></div
    ></el-dialog>
  </div>
</template>
